import { useState, useEffect, useContext } from 'react'
import { useField } from 'formik'
import { ApiFetch } from '../Api'
import UserContext from '../../../UserContext'
import Select from 'react-select'
import { Cell } from 'react-foundation'
import { DEFAULT_STATE } from '../../Preferences/stateServiceAreaConfig'

type CountySearchSelectProps = { name: string, title?: string, stateName?: string, hideLabel?: boolean, restricted?: boolean, includeAdjacent?: boolean }

const CountySearchSelect: React.FC<CountySearchSelectProps> = ({ name, title, stateName, hideLabel, restricted = true, includeAdjacent }) => {
    const [counties, setCounties] = useState<string[]>([])
    const { cachedGet } = useContext(UserContext)
    const { CacheLookupsMinutes } = window.CS_CONFIG
    const [, { value: selectedCounties }, { setValue }] = useField<string[] | undefined>(name)
    const [, { value: stateValue }, { setValue: setStateValue }] = useField<string>(stateName || 'countiesState')
    const [stateOptions, setStateOptions] = useState<string[]>([])
    const selectedState = stateValue || DEFAULT_STATE

    useEffect(() => {
        cachedGet(`ApiCountiesLookup_${selectedState}_${includeAdjacent ? '1' : '0'}`, CacheLookupsMinutes, () => ApiFetch<string[]>('County', {
            stateABbr: selectedState,
            restrictedCounties: restricted,
            includeAdjacent: includeAdjacent
        }))
            .then((result) => setCounties(result))
            // eslint-disable-next-line no-console
            .catch(console.log)
    }, [cachedGet, CacheLookupsMinutes, restricted, includeAdjacent, selectedState])

    useEffect(() => {
        //prefetch the rest
        stateOptions.forEach(o => {
            void cachedGet(`ApiCountiesLookup_${o}_${includeAdjacent ? '1' : '0'}`, CacheLookupsMinutes, () => ApiFetch<string[]>('County', {
                stateABbr: o,
                restrictedCounties: restricted,
                includeAdjacent: includeAdjacent
            }))
        })
    }, [cachedGet, CacheLookupsMinutes, restricted, includeAdjacent, stateOptions])

    useEffect(() => {
        // eslint-disable-next-line no-console
        console.log('Fetching states')
        cachedGet(`ApiStatesLookup_${includeAdjacent ? '1' : '0'}`, CacheLookupsMinutes, () => ApiFetch<string[]>('County/States', {
            restrictedCounties: restricted,
            includeAdjacent: includeAdjacent
        }))
            .then((result) => {
                setStateOptions(result)
            })
            // eslint-disable-next-line no-console
            .catch(console.log)
    }, [cachedGet, CacheLookupsMinutes, restricted, includeAdjacent])

    return (
        <>
            {!hideLabel && <label htmlFor={name}>{title || name}</label>}
            <Cell small={2} large={2}>
                <Select
                    placeholder='State'
                    className='reactSelect'
                    onChange={v => { if (v) setStateValue(v.value) }}
                    value={stateValue ? stateOptions.map(c => ({ value: c, label: c })).find(o => o.value === stateValue) : null}
                    options={stateOptions.map(c => ({ value: c, label: c }))}
                />
            </Cell>
            <Cell small={10} large={10}>
                <Select
                    isMulti
                    placeholder='County'
                    className='reactSelect'
                    options={counties.map(c => ({ value: c, label: c }))}
                    value={selectedCounties?.map(c => ({ value: c, label: c }))}
                    onChange={v => setValue(v.map(o => o.value))}
                />
            </Cell>
        </>
    )
}

export default CountySearchSelect
